import escapeRegExp from 'lodash-es/escapeRegExp';

export const isJson = val => {
    if (!val) return false;

    try {
        JSON.parse(val);
        return true;
    } catch (e) {
        return false;
    }
};

export const replaceAll = (str, find, replace) => {
    if (str) {
        return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
    } else {
        return '';
    }
};

/* export const htmlToJquery = html => {
    if (typeof html === "string") {
        return $('<div id="body-mock">' + html.replace(/^[\s\S]*<body.*?>|<\/body>[\s\S]*$/ig, '') + '</div>');
    } else {
        return $('<div id="body-mock">' + html + '</div>');
    }
}; */

export const plural = (word, count, ext = 's') => {
    return count + ' ' + pluralWord(word, count, ext);
};

export const pluralWord = (word, count, ext = 's') => {
    return word + (count > 1 ? ext : '');
};

export const removeTags = str => {
    if (!str) return false;
    return str.toString().replace(/(<([^>]+)>)/gi, '');
};

export const nl2br = str => String(str).replace(/(?:\r\n|\r|\n)/g, '<br>');
